(function(app, ng) {

    app.provider("transactionDocumentApi", [function() {
        this.$get = ["complianceHubApiGateway", "complianceHubBaseApiUrl", function (complianceHubApiGateway, complianceHubBaseApiUrl) {
            var service = {};

            //GETs
            service.get = function (transactionId, transactionDocumentId) {
                return complianceHubApiGateway.getFile("/Transactions/" + transactionId + "/Documents/" + transactionDocumentId, { headers: { "Accept": "application/pdf" } });
            };

            service.getUrl = function (transactionId, transactionDocumentId) {
                /*return complianceHubApiGateway.get("/Transactions/" + transactionId + "/Documents/" + transactionDocumentId);*/
                return complianceHubBaseApiUrl + "/Transactions/" + transactionId + "/Documents/" + transactionDocumentId;
            };

            service.getTransactionDocuments = function (transactionId) {
                return complianceHubApiGateway.getArray("/Transactions/" + transactionId + "/Documents");
            };

            service.getTransactionDocumentsByType = function (transactionId, type) {
                return complianceHubApiGateway.getArray("/Transactions/" + transactionId + "/Documents/Type/" + type);
            };

            //PUTs
            service.updateTransactionDocument = function (transactionId, transactionDocumentId, document) {
                return complianceHubApiGateway.putFile("/Transactions/" + transactionId + "/Documents/" + transactionDocumentId, document);
            };

            service.addTransactionDocument = function (transactionId, type, requiredFileName, document) {
                return complianceHubApiGateway.putFile("/Transactions/" + transactionId + "/Documents/" + type + "/" + requiredFileName, document);
            };

            //POSTs
            service.addAdditionalDocument = function (transactionId, document, type) {
                return complianceHubApiGateway.postFile("/Transactions/" + transactionId + "/Documents/" + type, document);
            };

            //DELETEs
            service.deleteDocument = function (transactionId, transactionDocumentId) {
                return complianceHubApiGateway.delete("/Transactions/" + transactionId + "/Documents/" + transactionDocumentId);
            };

            return service;

        }];
    }]);

})(window.app, window.angular); //jshint ignore:line